import styled from 'styled-components';
import { FlexGridContainer, FlexGridItem } from '@alinta-digital/asg';

export const StyledFlexGridContainer = styled(FlexGridContainer)`
  padding: 0;
`;

export const StyledFlexGridItem = styled(FlexGridItem)`
  @media only screen and (min-width: 1024px) {
    &.lastRow {
      margin-bottom: 0;
    }
  }

  @media only screen and (max-width: 1023px) {
    :last-child {
      margin-bottom: 0;
    }
  }
`;
